import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { handleToggleChat } from '../../../../store/slices/generalSlice';
import { FormLayout } from '../../../../global-styles/layout';
import { WHATSAPP_URL } from '../../../../constants/env';
import CardChatWhatsapp from '../../../../components/card-chat/card-chat-wa';
import CardChat from '../../../../components/card-chat/card-chat';
import { ChatStyle } from './chat-style';

interface IChatTab {
  isWhatsapp: boolean;
}

const Chat: React.FC<IChatTab> = ({ isWhatsapp }) => {
  const { t } = useTranslation(['aia']);
  const dispatch = useDispatch();

  return (
    <ChatStyle>
      <FormLayout>
        {isWhatsapp ? (
          <CardChatWhatsapp
            onClick={() => {
              window.open(WHATSAPP_URL, '_new', 'noopener,noreferrer');
            }}
            title={t('aia:chat.whatsapp')}
          />
        ) : (
          <CardChat
            onClick={() => {
              dispatch(handleToggleChat());
            }}
            title={t('aia:chat.start')}
            started={true}
            unread={0}
          />
        )}
      </FormLayout>
    </ChatStyle>
  );
};

export default Chat;
